import React from "react";
import "../../../assets/css/TeamCollaboration.css";
import { motion } from "framer-motion";

export default function WorkTogether() {
  return (
    <div>
      <div className="hero-container-TeamCollaboration">
        <div className="hero-content-TeamCollaboration">
          <div className="hero-content-TeamCollaboration_margin">
            {/* Header Badge */}
            <div className="hero-badge-TeamCollaboration">
              <svg
                className="badge-icon-TeamCollaboration"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
              >
                <path d="M11.017 2.814a1 1 0 0 1 1.966 0l1.051 5.558a2 2 0 0 0 1.594 1.594l5.558 1.051a1 1 0 0 1 0 1.966l-5.558 1.051a2 2 0 0 0-1.594 1.594l-1.051 5.558a1 1 0 0 1-1.966 0l-1.051-5.558a2 2 0 0 0-1.594-1.594l-5.558-1.051a1 1 0 0 1 0-1.966l5.558-1.051a2 2 0 0 0 1.594-1.594z" />
                <path d="M20 2v4" />
                <path d="M22 4h-4" />
                <circle cx="4" cy="20" r="2" />
              </svg>
              <span>Intelligent Team Management</span>
            </div>

            {/* Main Heading */}
            <h1 className="hero-heading-TeamCollaboration">
              One Team. One Task View.
              <br />
              <span className="hero-heading-TeamCollaboration-gradient">
                Zero Confusion.
              </span>
            </h1>

            {/* Description */}
            <p className="hero-description">
              Simplifyte helps professional teams assign work, discuss updates, manage files
              <br className="desktop-break" />
              review approvals, and close tasks with clear ownership and complete history.
            </p>

            <div className="hero-divider"></div>

            {/* Value Highlight Strip */}
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 1 }}
              className="wt-value-strip"
            >
              <motion.div
                className="wt-value-block"
                initial={{ opacity: 0, y: 16 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 1.2, type: "spring", stiffness: 80 }}
              >
                <h3 className="wt-value-heading">Clear Ownership</h3>
                <p className="wt-value-desc">
                  Every task has an assignee, deadline and status.
                </p>
              </motion.div>

              <div className="wt-value-divider" />

              <motion.div
                className="wt-value-block"
                initial={{ opacity: 0, y: 16 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 1.4, type: "spring", stiffness: 80 }}
              >
                <h3 className="wt-value-heading">Faster Reviews</h3>
                <p className="wt-value-desc">
                  Team leads can check and approve work before closure.
                </p>
              </motion.div>

              <div className="wt-value-divider" />

              <motion.div
                className="wt-value-block"
                initial={{ opacity: 0, y: 16 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 1.6, type: "spring", stiffness: 80 }}
              >
                <h3 className="wt-value-heading">Less Follow-up</h3>
                <p className="wt-value-desc">
                  Comments, files and updates stay attached to the task.
                </p>
              </motion.div>
            </motion.div>
          </div>
        </div>
      </div>
    </div>
  );
}
